import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

// prepere to https://github.com/reactjs/react-router-redux 
// so when version 5 will be ready i will able to change it quickly 
// in the future it will be:
// import { push } from 'react-router-redux'
export const redirect = history.push; // for handle redirect 


// WEBPACK FOOTER //
// ./src/utils/history.js